import { render, staticRenderFns } from "./ModalCancelOrder.vue?vue&type=template&id=1fb08eb1&"
import script from "./ModalCancelOrder.vue?vue&type=script&lang=js&"
export * from "./ModalCancelOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports